module.exports = __webpack_public_path__ + "static/media/prb-nutri-cartao-visita-02-768x579.28fc5c5f.jpg";